import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';

import {
  MeetingEventsSidebar,
  EmptyState,
  WalkthroughPopup,
  JoinCallModal,
  EmptyStateText,
} from '../../../features/call-recordings';

import { callModel } from '../../../features/call';
import { Loader } from '../../../shared/ui';

import { AppMainLayout } from '../../../widgets/app-layout';

import { CallsHeader, CallTabs } from '../../../features/call-recordings';

export const CallRecordingsPage = () => {
  const hasCalls = useSelector(callModel.selectors.selectHasCalls);

  const isCallsDataReady = useSelector(
    callModel.selectors.selectIsCallsDataReady
  );

  if (!isCallsDataReady) {
    return (
      <AppMainLayout isWorkspace>
        <Loader />
      </AppMainLayout>
    );
  }

  return (
    <>
      <Helmet titleTemplate="Call Recordings - Distribute" />
      <main className="md:m-0 mb-2 relative flex flex-col flex-1 min-w-0 bg-base-white border border-gray-200 md:border-none md:rounded-none rounded-xl">
        <div className="flex flex-1 overflow-y-auto sm:p-5 p-6">
          <div className="sm:px-1 sm:pt-1 min-w-0 flex flex-col flex-1 gap-y-4">
            <CallsHeader />
            {hasCalls ? (
              <CallTabs />
            ) : (
              <EmptyState description={EmptyStateText.default} />
            )}
          </div>
        </div>
      </main>
      <MeetingEventsSidebar />
      <WalkthroughPopup />
      <JoinCallModal />
    </>
  );
};
